import { createAction, props } from '@ngrx/store';
import { PageDto } from '../api/core';
import { CreateSimcardDto } from '../api/core/models/create-simcard-dto';
import { UpdateSimcardDto } from '../api/core/models/update-simcard-dto';
import { FilterParams } from '../router';
import { SimCardActionTypes } from './sim-cards.models';

export const loading = createAction(SimCardActionTypes.LOADING);
export const decreaseLoading = createAction(SimCardActionTypes.DECREASE_LOADING);
export const addSimCard = createAction(SimCardActionTypes.ADD_SIM_CARD, props<{ simcard: CreateSimcardDto }>());
export const addedSimCard = createAction(SimCardActionTypes.ADDED_SIM_CARD, props<{ simcard?: CreateSimcardDto }>());
export const loadSimCards = createAction(SimCardActionTypes.LOAD_SIM_CARDS, props<{ params: FilterParams }>());
export const loadedSimCards = createAction(SimCardActionTypes.LOADED_SIM_CARDS, props<{ data: PageDto }>());
export const updateSimCard = createAction(SimCardActionTypes.UPDATE_SIM_CARD, props<{ iccid: string; simCard: UpdateSimcardDto }>());
export const updatedSimCard = createAction(SimCardActionTypes.UPDATED_SIM_CARD, props<{ iccid: string; simCard: UpdateSimcardDto }>());
export const deleteSimCard = createAction(SimCardActionTypes.DELETE_SIM_CARD, props<{ iccid: string }>());
export const deletedSimCard = createAction(SimCardActionTypes.DELETED_SIM_CARD, props<{ iccid: string }>());
